import type { IPatientCaregiver } from "../../../core/ports/driver/VisitNotesService";

export const buildPatientCaregiverUrl = ({
  collectionRoute,
  itemRoute,
  clinicId,
  patientId,
  caregiverId,
}: {
  collectionRoute: string;
  itemRoute: string;
  clinicId: number;
  patientId: number;
  caregiverId?: string;
}): string =>
  (caregiverId ? itemRoute : collectionRoute)
    .replace("{clinic_id}", clinicId.toString())
    .replace("{patient_id}", patientId.toString())
    .replace("{caregiver_id}", encodeURIComponent(caregiverId || ""));

export const caregiverFromApiResponse = (
  response: any
): IPatientCaregiver | null => {
  const data = response?.data || response;
  const caregiver = data?.caregiver || data;
  return typeof caregiver?.id === "string" &&
    typeof caregiver?.name === "string" &&
    typeof caregiver?.relationship === "string"
    ? caregiver
    : null;
};

export const caregiversFromApiResponse = (
  response: any
): IPatientCaregiver[] | null => {
  const data = response?.data || response;
  const caregivers = Array.isArray(data) ? data : data?.caregivers;
  return Array.isArray(caregivers) ? caregivers : null;
};
